import React, { useState } from "react";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { CreateDeliveryParams } from "@/lib/types/delivery.types";
import { CreateDeliveryDialog } from "./create-delivery-dialog.component";
import { Plus } from "lucide-react";
import { cn } from "@/dentlab/src/lib/util";

export const CreateDeliveryButton: React.FC = () => {
	const { job, createDelivery } = useJobStore((state) => ({
		job: state.job,
		createDelivery: state.createDelivery,
	}));
	const [dialogOpen, setDialogOpen] = useState(false);

	if (!job?.id) return null;

	const handleCreate = async (params: CreateDeliveryParams) => {
		await createDelivery(params);
	};

	return (
		<>
			<button
				onClick={() => setDialogOpen(true)}
				className={cn(
					"cursor-pointer bg-white hover:bg-neutral-100 rounded-sm text-sm px-3 py-1.5 flex items-center gap-1 border h-6"
				)}
				data-testid="delivery-create-button"
				aria-label="Neue Lieferung erstellen"
			>
				<Plus className="text-gray-700" size="14px" />
				<span className="whitespace-nowrap text-ellipsis overflow-hidden text-gray-700">
					Neu
				</span>
			</button>
			<CreateDeliveryDialog
				open={dialogOpen}
				onOpenChange={setDialogOpen}
				jobId={job.id}
				onSubmit={handleCreate}
			/>
		</>
	);
};
